import type { AudiobookManifest, AudiobookManifestEntry } from '../types/audiobooks';

export function sortManifestByIndex(manifest: AudiobookManifest): AudiobookManifestEntry[] {
  return Object.values(manifest).sort((a, b) => a.index - b.index);
}
